// Lightweight i18n: UI defaults to its original (Slovak/English) strings;
// users whose account has country === 'cz' get the Czech dictionary below.
// The country comes from the login response and is stored in localStorage 'user'.
// Usage: t('Uložiť') or with params: t('{loaded} of {total} images loaded', { loaded: 3, total: 10 })

const cz: Record<string, string> = {
  // Sidebar
  'Správa vozidiel': 'Správa vozidel',
  'Nastavenia': 'Nastavení',
  'Prihlásený používateľ': 'Přihlášený uživatel',

  // CarListPage
  'Moje autá': 'Moje auta',
  'Interval vymazania a opätovného nahrania': 'Interval smazání a opětovného nahrání',
  '2 dni': '2 dny',
  '3 dni': '3 dny',
  '4 dni': '4 dny',
  '5 dni': '5 dní',
  '7 dni': '7 dní',
  '8 dni': '8 dní',
  '14 dni': '14 dní',
  '30 dni': '30 dní',
  'Zapnúť': 'Zapnout',
  'Vypnúť': 'Vypnout',
  'Vypnúť všetky': 'Vypnout všechny',
  'Počet vozidiel': 'Počet vozidel',
  'Aktívne vozidlá': 'Aktivní vozidla',
  'Obnova o': 'Obnova za',
  'Podľa účtu': 'Podle účtu',
  'Obnova': 'Obnova',
  'Topovať': 'Topovat',
  'Topovanie zapnuté': 'Topování zapnuto',
  'dní': 'dní',
  'Loading settings...': 'Načítání nastavení...',
  'Failed to load user settings': 'Nepodařilo se načíst nastavení',

  // SettingsPage
  'Nastavenia používateľa': 'Nastavení uživatele',
  'Načítavam údaje používateľa...': 'Načítám údaje uživatele...',
  'Nie ste prihlásený': 'Nejste přihlášeni',
  'Nepodarilo sa načítať údaje': 'Nepodařilo se načíst údaje',
  'Chyba pri načítaní údajov': 'Chyba při načítání údajů',
  'BZS používateľské meno nemôže byť prázdne': 'BZS uživatelské jméno nemůže být prázdné',
  'Nepodarilo sa uložiť zmeny': 'Nepodařilo se uložit změny',
  'BZS používateľské meno bolo úspešne aktualizované': 'BZS uživatelské jméno bylo úspěšně aktualizováno',
  'Chyba pri ukladaní zmien': 'Chyba při ukládání změn',
  'Používateľské meno': 'Uživatelské jméno',
  'Používateľské meno BZS': 'Uživatelské jméno BZS',
  'Zadajte BZS používateľské meno': 'Zadejte BZS uživatelské jméno',
  'Ukladám...': 'Ukládám...',
  'Uložiť': 'Uložit',
  'Telefónne číslo': 'Telefonní číslo',
  'Nie je zadané': 'Není zadáno',
  'Krajina': 'Země',
  'Poukážky Bazoš': 'Poukázky Bazoš',
  'Jeden kód na riadok': 'Jeden kód na řádek',
  'uložené kódy': 'uložené kódy',
  'Uložiť kódy': 'Uložit kódy',
  'pridajú sa k uloženým': 'přidají se k uloženým',
  'Pridá sa': 'Přidá se',
  'už v zozname': 'už v seznamu',
  'Pridané kódy: {count}': 'Přidané kódy: {count}',
  'Tieto kódy už v zozname sú': 'Tyto kódy už v seznamu jsou',
  'Zobraziť všetky': 'Zobrazit všechny',
  'Zobraziť menej': 'Zobrazit méně',
  'nepoužitých z': 'nepoužitých z',
  'pridajte nové kódy': 'přidejte nové kódy',
  'čoskoro dôjdu': 'brzy dojdou',
  'Nepoužité': 'Nepoužité',
  'Použité': 'Použité',
  'Kódy boli úspešne uložené': 'Kódy byly úspěšně uloženy',
  'Nepodarilo sa uložiť kódy': 'Nepodařilo se uložit kódy',
  'Chyba pri ukladaní kódov': 'Chyba při ukládání kódů',
  'Zmena hesla': 'Změna hesla',
  'Aktuálne heslo': 'Aktuální heslo',
  'Nové heslo': 'Nové heslo',
  'Potvrďte nové heslo': 'Potvrďte nové heslo',
  'Zmeniť heslo': 'Změnit heslo',
  'Vyplňte všetky polia hesla': 'Vyplňte všechna pole hesla',
  'Nové heslo musí mať aspoň 8 znakov': 'Nové heslo musí mít alespoň 8 znaků',
  'Heslá sa nezhodujú': 'Hesla se neshodují',
  'Aktuálne heslo je nesprávne': 'Aktuální heslo je nesprávné',
  'Chyba pri zmene hesla': 'Chyba při změně hesla',
  'Heslo bolo úspešne zmenené': 'Heslo bylo úspěšně změněno',

  // AutobazarListings
  'No listings found in your Autobazar feed.': 'Ve vašem feedu nebyly nalezeny žádné inzeráty.',
  'Failed to load listings': 'Nepodařilo se načíst inzeráty',
  'No listings data received from server': 'Ze serveru nebyla přijata žádná data inzerátů',
  'Listing states saved successfully!': 'Stavy inzerátů byly úspěšně uloženy!',
  'Failed to save listing states. Please try again.': 'Nepodařilo se uložit stavy inzerátů. Zkuste to prosím znovu.',
  'Dosiahli ste limit {max} aktívnych inzerátov na účet. Deaktivujte niektoré inzeráty, ak chcete aktivovať ďalšie.':
    'Dosáhli jste limitu {max} aktivních inzerátů na účet. Pokud chcete aktivovat další, deaktivujte některé inzeráty.',

  // ImageSelectionPopup
  'Select Images': 'Výběr obrázků',
  'Loading images...': 'Načítání obrázků...',
  'This may take a moment while we process the XML feed': 'Může to chvíli trvat, zpracováváme data inzerátu',
  'No images found for this listing.': 'Pro tento inzerát nebyly nalezeny žádné obrázky.',
  'Loading...': 'Načítání...',
  'Cancel': 'Zrušit',
  'Saving...': 'Ukládám...',
  'Save Selection': 'Uložit výběr',
  '{loaded} of {total} images loaded': '{loaded} z {total} obrázků načteno',
  '{count} previously selected photos no longer exist': '{count} dříve vybraných fotek už neexistuje',
  'Failed to load images. Please try again.': 'Nepodařilo se načíst obrázky. Zkuste to prosím znovu.',
  'Failed to save selection. Please try again.': 'Nepodařilo se uložit výběr. Zkuste to prosím znovu.',
  'Failed to save description. Please try again.': 'Nepodařilo se uložit popis. Zkuste to prosím znovu.',
};

function getCountry(): string {
  try {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      return parsed.country || '';
    }
  } catch (err) {
    // Ignore parse errors - fall back to default language
  }
  return '';
}

export function t(text: string, params?: Record<string, string | number>): string {
  let result = getCountry() === 'cz' && cz[text] ? cz[text] : text;
  if (params) {
    Object.keys(params).forEach(key => {
      result = result.replace(`{${key}}`, String(params[key]));
    });
  }
  return result;
}
